import { createSelector } from 'reselect';

export const businessAdherentsSelector = (state) => state.business.adherents;

export const sortedBusinessAdherentsSelector = createSelector([businessAdherentsSelector], (items) => {
  return [...items].sort((a, b) => a.lastName.toString().localeCompare(b.lastName.toString()));
});

export const businessesSelector = (state) => state.business.businesses;
